import * as moment from "moment";
import NotificationBase from "../NotificationBase";
import {JobStatusNotificationDataApiDto, NotificationBaseApiDto} from "../../../api/model/rest";
import {getUser} from "../../../store/view/user";
import JobStatusNotificationData from "./JobStatusNotificationData";
import {getJobStatus} from "../../../store/view/jobStatus";
import {Option} from "ts-option";

/**
 * Comment notification class.
 */
export default class JobStatusNotification extends NotificationBase {
	/**
	 * @param {string} id Notification id.
	 * @param {moment.Moment} visibleFrom Notification datetime.
	 * @param {boolean} read Flag if comment is marked as read.
	 * @param {"JOB_STATUS"} type notification type, in this case always 'JOB_STATUS'.
	 * @param {JobStatusNotificationData} data Job history notification data object.
	 */
	constructor(public readonly id: string,
		public readonly visibleFrom: moment.Moment,
		public readonly read: boolean,
		public readonly type: string,
		public readonly data: JobStatusNotificationData) {
		super(id, visibleFrom, read, type);
	}

	static fromJson(json: NotificationBaseApiDto): JobStatusNotification {
		return new JobStatusNotification(json.id, moment(json.visibleFrom), json.read, json.type,
			JobStatusNotificationData.fromJson(json.data as JobStatusNotificationDataApiDto));
	}

	/**
	 * Display user Full name.
	 * @returns {string}
	 */
	displayCreatorName() {
		return getUser(this.data.creator.id).map(u => u.getDisplayName()).getOrElse(this.data.creator.id);
	}

	/**
	 * Get previous status label.
	 * @returns {Option<string>}
	 */
	getPreviousStatusLabel(): Option<string> {
		return getJobStatus(this.data.previousStatusId).map(ps => ps.getStatusLabel());
	}

	/**
	 * Get current status label.
	 * @returns {Option<string>}
	 */
	getCurrentStatusLabel(): Option<string> {
		return getJobStatus(this.data.currentStatusId).map(cs => cs.getStatusLabel());
	}

	/**
	 * Get notification icon depending on current job status.
	 * @returns {string}
	 */
	getNotificationIcon() {
		return getJobStatus(this.data.currentStatusId).map(cs => cs.getStatusIcon()).orNull;
	}

	copy({id = this.id, dateTime = this.visibleFrom, read = this.read, type = this.type, data = this.data}) {
		return new JobStatusNotification(id, dateTime, read, type, data);
	}
}
